// Add new posts here - newest first
// Use template literals for markdown content

const posts = [
  { slug: 'beginner-energy', title: 'We Could All Do With Some More Beginner Energy', date: '2026-07-19', image: '/sf.jpeg' },
  { slug: 'raising-an-agent', title: 'Raising an Agent', date: '2026-02-11' },
  { slug: 'why-does-sidekit-exist', title: 'Why does Sidekit exist?', date: '2026-01-15', external: 'https://appsidekit.com/blog/why-does-sidekit-exist' },
];

export default posts;
